module.exports = __webpack_public_path__ + "static/media/31JFA5.79937e73.jpg";